import { lazy, Suspense } from 'react';
import type { TelaRelatorio } from './registro';

/** A implementação (menu, diálogo, relatórios, exceljs/jsPDF) vem em outro arquivo carregado sob demanda: o bundle inicial só leva este invólucro. */
const Impl = lazy(() => import('./botao-relatorios-impl').then((m) => ({ default: m.BotaoRelatoriosImpl })));

export interface BotaoRelatoriosProps {
  tela: TelaRelatorio;
  /** Filtros e ids da tela (viram query/rota dos relatórios). */
  params?: Record<string, string | undefined>;
  /** Resposta que a tela já exibe (formação, simulador). */
  dados?: unknown;
  className?: string;
}

export function BotaoRelatorios(props: BotaoRelatoriosProps) {
  return (
    <Suspense fallback={null}>
      <Impl {...props} />
    </Suspense>
  );
}
